
export enum eliminationStatuses {
    NotEliminated = 'notEliminated',
    Eliminated = 'eliminated',
}
